webpackJsonp([342],{

/***/ 1197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformTagTable_vue__ = __webpack_require__(2909);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8565e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformTagTable_vue__ = __webpack_require__(5189);
function injectStyle (ssrContext) {
  __webpack_require__(5187)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformTagTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8565e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformTagTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dynamicTags: [],
      form: {
        name: null
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.getHotTag();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getHotTag', 'deleteHotTag', 'addHotTag']), {
    getHotTag: function getHotTag() {
      var _this = this;

      return request.page('getHotTag').then(function (res) {
        _this.dynamicTags = [];
        for (var i = 0; i < res.data.data.length; i++) {
          _this.dynamicTags.push(res.data.data[i]);
        }
      });
    },
    handleClose: function handleClose(tagId) {
      var _this2 = this;

      return request.common('deleteHotTag', tagId).then(function (res) {
        _this2.getHotTag();
      });
    },
    addHotTag: function addHotTag() {
      var _this3 = this;

      if (this.dynamicTags.length >= 20) {
        this.$message({
          showClose: true,
          message: '热搜标签数量已经大于等于20个，无法添加',
          type: 'error'
        });
        return false;
      }
      if (!this.form.name || this.form.name.length <= 0) {
        this.$message({
          showClose: true,
          message: '请输入标签名称',
          type: 'error'
        });
        return false;
      }
      for (var i = 0; i < this.dynamicTags.length; i++) {
        if (this.form.name === this.dynamicTags[i].name) {
          this.$message({
            showClose: true,
            message: '不能添加重复的标签',
            type: 'error'
          });
          return false;
        }
      }
      return request.common('addHotTag', this.form).then(function (res) {
        _this3.form.name = '';
        _this3.getHotTag();
      });
    }
  })
});

/***/ }),

/***/ 5187:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5188);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("edb80784", content, true, {});

/***/ }),

/***/ 5188:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".button-new-tag,.el-tag+.el-tag{margin-left:10px}.button-new-tag{height:32px;line-height:30px;padding-top:0;padding-bottom:0}.input-new-tag{width:90px;margin-left:10px;vertical-align:bottom}", "", {"version":3,"sources":["/workspace/src/views/platform/pages/PlatformTagTable.vue"],"names":[],"mappings":"AAIA,gCAFE,gBAAkB,CAQnB,AAND,gBAEE,YAAa,AACb,iBAAkB,AAClB,cAAe,AACf,gBAAkB,CACnB,AACD,eACE,WAAY,AACZ,iBAAkB,AAClB,qBAAuB,CACxB","file":"PlatformTagTable.vue","sourcesContent":["\n.el-tag + .el-tag {\n  margin-left: 10px;\n}\n.button-new-tag {\n  margin-left: 10px;\n  height: 32px;\n  line-height: 30px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.input-new-tag {\n  width: 90px;\n  margin-left: 10px;\n  vertical-align: bottom;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("平台管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{nativeOn:{"submit":function($event){$event.preventDefault();return _vm.addHotTag()}}},[_vm._l((_vm.dynamicTags),function(tag,index){return _c('el-tag',{key:index,attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.handleClose(tag.id)}}},[_vm._v(_vm._s(tag.name)+"\n      ")])}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),[_c('el-col',{attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":"请输入内容"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-col',{attrs:{"offset":1,"span":2}},[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("添加\n          ")])],1)]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/platform-tag-table.bf85a821b0c62c75d999.js